export default "__VITE_ASSET__BDgvz9$5__"